import React, {Component} from 'react';
import PropTyeps from 'prop-types';
import {observer} from 'mobx-react';
import {action, observable} from 'mobx';
import {withStyles} from '@material-ui/core/styles';
import Slider from '@material-ui/lab/Slider';
import isNumber from 'lodash/isNumber';
import {colorPaletteList, white} from '../themes/colors';

@observer
class VolumeSlider extends Component {
    getEndColor = (color) => {
        try {
            return colorPaletteList.find(x => x.value[0] === this.props.color).value[1]
        } catch (err) {
            return color;
        }
    }
    sliderStyles = () => ({
        trackColor: {
            backgroundColor: white,
            borderRadius: '2px'
        },
        thumb: {
            width: 20,
            height: 20,
            border: '2px solid #363437',
            boxShadow: 'none !important',
            background: `radial-gradient(circle, ${this.props.color} 0%, ${this.getEndColor(this.props.color)} 100%)`
        }
    });

    @observable volume = isNumber(this.props.volume) ? this.props.volume : 0.5;
    @observable prevVolume = 0.5;

    componentWillUpdate(nextProps) {
        if (nextProps.volume !== this.props.volume) {
            this.setVolume(nextProps.volume);
        }
    }

    @action setVolume = (volume) => {
        this.volume = volume;
    };

    @action handleVolumeDragStop = () => {
        if (this.volume) {
            this.prevVolume = this.volume;
        }
    };

    @action updateVolumeLevel = (event, newVolume) => {
        this.volume = newVolume;
        if (this.props.onChange) {
            this.props.onChange(this.volume);
        }
    };

    @action toggleMute = () => {
        this.volume = (this.volume === 0) ? this.prevVolume : 0;
        this.props.onChange(this.volume);
    };

    isMute = () => {
        return this.volume === 0;
    };

    renderContent = ({classes}) => {
        const {label, disabled, vertical} = this.props;
        const sliderClasses = {
            root: `volume-slider ${this.volume ? '' : 'muted'}`,
            trackBefore: 'volume-trackBefore',
            trackAfter: 'volume-trackAfter',
            thumb: classes.thumb,
            focused: 'volume-focused',
            disabled: 'volume-disabled',
            activated: 'volume-activated',
            track: classes.trackColor
        };
        return (
            <div className="flexbox-fill range">
                <div className="flexbox-fill flex-center light-gray">
                    {label && <span
                        className="bold sonar-medium"
                        style={{marginRight: 18}}>{label}</span>}
                    <Slider
                        classes={sliderClasses} max={1} value={this.volume} disabled={disabled} vertical={vertical}
                        onChange={this.updateVolumeLevel} onDragEnd={this.handleVolumeDragStop}/>
                </div>
            </div>
        );
    };

    Styled = withStyles(this.sliderStyles)(this.renderContent);

    render() {
        return <this.Styled/>;
    }
}

VolumeSlider.propTypes = {
    onChange: PropTyeps.func,
    volume: PropTyeps.number,
    disabled: PropTyeps.bool,
    vertical: PropTyeps.bool
};

export default VolumeSlider;
